export default [
  {
    path: 'alliances',
    name: 'alliances',
    component: () => import('@/views/Alliance/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'alliance',
      template: 'auth',
    },
  },
];
